import { ChangeDetectionStrategy, Component, ElementRef, input, output, viewChild } from '@angular/core';

/**
 * Title bar ultra-compacta del módulo activo (DESIGN.md §4.1).
 *
 * Reemplaza el header genérico anterior (logo + búsqueda + usuario + logout):
 * los datos del usuario viven en el footer de sesión de `app-sidebar`, y la
 * búsqueda global no tenía función real conectada. Este componente renderiza
 * título + badge del módulo + descripción opcional, resueltos por
 * `MainLayoutComponent` a partir de la ruta activa, más un botón de logout
 * solo-ícono siempre visible (el footer del sidebar se oculta al colapsarlo).
 *
 * En móvil (US-097) muestra además, a la izquierda, el botón que abre el menú
 * lateral como panel superpuesto. Qué se muestra lo decide `MainLayoutComponent`.
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  /** Título de la sección activa (h1). Viene de `data.breadcrumb` de la ruta hoja. */
  title = input('');

  /** Nombre real del módulo (primer segmento de ruta), mostrado como píldora junto al título. */
  badge = input('');

  /** Descripción corta, separada del título por "|". Se omite si no hay fuente real. */
  description = input('');

  /** Muestra el botón de menú (hamburguesa) a la izquierda. Solo en móvil. */
  showMenuButton = input(false);

  /** Si el panel de menú que controla el botón está abierto (`aria-expanded`). */
  menuExpanded = input(false);

  /** Cierre de sesión desde el ícono de salida. */
  logout = output<void>();

  /** Pulsación del botón de menú. */
  menuToggle = output<void>();

  private readonly menuButton = viewChild<ElementRef<HTMLButtonElement>>('menuButton');

  /** Devuelve el foco al botón de menú (al cerrar el panel móvil). */
  focusMenuButton(): void {
    this.menuButton()?.nativeElement.focus();
  }
}
